export const LOAD_INITIAL_DATA_REQUEST = 'LOAD_INITIAL_DATA_REQUEST';
export const LOAD_INITIAL_DATA_SUCCESS = 'LOAD_INITIAL_DATA_SUCCESS';
export const LOAD_INITIAL_DATA_ERROR = 'LOAD_INITIAL_DATA_ERROR';
export const RESET_INITIAL_STATUS = 'RESET_INITIAL_STATUS';

export const SET_LANGUAGE = 'SET_LANGUAGE';
